// GasFactorLine.jsx
import { toScientific } from "../library/helper"; // adjust path

function sciPretty(num, digits = 2) {
    const s = toScientific(num, digits); // e.g. "5.01e-4"
    if (!s) return "";
    const m = String(s).match(/^(-?\d+(?:\.\d+)?)[eE]([+-]?\d+)$/);
    if (!m) return s;
    const [, mantissa, exp] = m;
    return { mantissa, exp };
}

const DEFAULT_GAS_MAP = [
    ["co2", "CO₂"],
    ["ch4", "CH₄"],
    ["n2o", "N₂O"],
    ["hfcs", "HFCs"],
    ["pfcs", "PFCs"],
    ["sf6", "SF₆"],
    ["nf3", "NF₃"],

    // biomass
    ["co2_biomass", "CO₂ (bio)"],
    ["ch4_biomass", "CH₄ (bio)"],
    ["n2o_biomass", "N₂O (bio)"],
    ["hfcs_biomass", "HFCs (bio)"],
    ["pfcs_biomass", "PFCs (bio)"],
    ["sf6_biomass", "SF₆ (bio)"],
    ["nf3_biomass", "NF₃ (bio)"],
];

export default function EmissionFactorLine({
    data,
    yearKey = "year",
    digits = 2,
    prefix = "",
    showPrefix = false,
    emptyText = "No gas factors",
    style,
    gasMap = DEFAULT_GAS_MAP,
}) {
    if (!data) return <div style={{ fontSize: 12, color: "#6b7280", ...style }}>-</div>;

    const year = data?.[yearKey];

    const gases = gasMap
        .filter(([k]) => data[k] !== null && data[k] !== undefined && data[k] !== "") // keeps 0
        .map(([k, label]) => ({ label, pretty: sciPretty(data[k], digits) }))
        .filter((g) => g.pretty !== "");

    return (
        <div style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.35, ...style }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "baseline" }}>
                {year != null && year !== "" && (
                    <span style={{ fontWeight: 600, color: "#4b5563" }}>{year}</span>
                )}

                {showPrefix && gases.length > 0 && <span style={{ color: "#9ca3af" }}>•</span>}
                {showPrefix && gases.length > 0 && <span style={{ color: "#6b7280" }}>{prefix}</span>}

                {gases.length === 0 ? (
                    <span style={{ color: "#9ca3af" }}>{emptyText}</span>
                ) : (
                    gases.map((g, idx) => (
                        <span
                            key={`${g.label}-${idx}`}
                            style={{
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 4,
                                padding: "1px 6px",
                                borderRadius: 999,
                                background: "#f3f4f6",
                                color: "#374151",
                            }}
                        >
                            <span style={{ fontWeight: 600 }}>{g.label}</span>

                            {typeof g.pretty === "string" ? (
                                <span style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" }}>
                                    {g.pretty}
                                </span>
                            ) : (
                                <span style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" }}>
                                    {g.pretty.mantissa}×10
                                    <sup style={{ fontSize: 10 }}>{g.pretty.exp}</sup>
                                </span>
                            )}
                        </span>
                    ))
                )}
            </div>
        </div>
    );
}
